module.exports = __webpack_public_path__ + "images/shimo/board-grid-fd657056034a247339b2ef9eed73d97e.png";